import {Component, OnInit} from '@angular/core';
import {RemoteManagerApiService} from '../../../services/api/settings/administration/remote-manager/remote-manager-api.service';
import {UserPrivilegeService} from '../../../services/common/user-privilege/user-privilege.service';
import {LoaderService} from '../../../services/common/loader-service/loader.service';


@Component({
  selector: 'remote-manager',
  templateUrl: './remote-manager.component.html',
  styleUrls: ['./remote-manager.component.scss']
})
export class RemoteManagerComponent implements OnInit {

  canSubmit: boolean;

  securityMode = [
    {label: 'Secured', value: 'secured'},
    {label: 'Unsecured', value: 'unsecured'}
  ];

  remoteManager: any  = {isAlarmForwardingEnabled: false, isJournalForwardingEnabled: false};

  constructor(private remoteManagerApiService: RemoteManagerApiService,
              private userPrivilege: UserPrivilegeService,
              private loaderService: LoaderService) {}

  ngOnInit(): void {
    this.loaderService.showMainContainer();
    this.canSubmit = this.userPrivilege.isAuthorized();
    this.initialization();
  }

  submit(): void {
    const parameters = Object.assign({}, this.remoteManager);
    delete parameters.username;
    delete parameters.securityMode;
    delete parameters.httpPort;
    delete parameters.httpsPort;

    this.remoteManagerApiService.updateRemoteManagerConfiguration(parameters).subscribe((remoteManager) => {
      this.setRemoteManagerValues(remoteManager);
    });
  }

  initialization(): void {
    this.remoteManagerApiService.getRemoteManagerConfiguration().subscribe((remoteManager) => {
      this.setRemoteManagerValues(remoteManager);
      this.loaderService.hideMainContainer();
    });
  }

  setRemoteManagerValues(remoteManager): void {
    this.remoteManager.isAlarmForwardingEnabled = remoteManager.isAlarmForwardingEnabled;
    this.remoteManager.isJournalForwardingEnabled = remoteManager.isJournalForwardingEnabled;
    this.remoteManager.host = remoteManager.primaryAddress;
    this.remoteManager.httpPort = remoteManager.httpPort;
    this.remoteManager.httpsPort = remoteManager.httpsPort;
    this.remoteManager.username = remoteManager.username;
    this.remoteManager.securityMode = remoteManager.securityMode;
  }
}
